import _ from 'lodash';

// constants
import { THUMB_20 } from './constant';

const generateThumb = ({ url }) => {
  // ----- COMMON FORMAT -> eventify/folder/subfolder/test_image.ext

  // --- splitting DB iimage path by '/'
  let splitArr = url.split('/');
  // ['eventify', 'filder', 'subfolder', 'test_image.ext']

  // --- accessing image name 'test_image.ext'
  let imageName = splitArr[splitArr.length - 1];

  // --- appending thumb constant on filename
  imageName = THUMB_20 + imageName;

  // --- setting image name back to the split arr
  splitArr[splitArr.length - 1] = imageName;
  // ['eventify', 'filder', 'subfolder', 'thumb20_test_image.ext']

  // --- recreating the image URL
  const newUrl = splitArr.join('/');
  // eventify/folder/subfolder/thumb20_test_image.ext

  // --- returning same URL as HUB doesn't has the same functionality yet
  // return newUrl;
  return url;
};

export default generateThumb;
